import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from 'rxjs';
import { AbRelatorioPrimeiroAcesso } from 'app/abstract/full-pages/relatorios/relatorio-primeiro-acesso.abstract';

@Injectable({ providedIn: 'root' })
export class RelatorioPrimeiroAcessoServices extends AbRelatorioPrimeiroAcesso {


  constructor(http: HttpClient) {

    super(http);

  }

  public getAllTenants(filter: AppFilter): Observable<any> {

    return this.getAll(`relatorio_primeiro_acesso/filter/`, filter.encode());

  }

}